import { render } from "./Calculator.vue?vue&type=template&id=766f08b2"
import script from "./Calculator.vue?vue&type=script&lang=js"
export * from "./Calculator.vue?vue&type=script&lang=js"
script.render = render

export default script